<template>
  <v-card height="430px" width="315px" @click="goToShowProduct(product.id)" class="pointer">
    <v-layout row wrap text-md-center>
      <v-flex sm12 pt-3>
        <img :src="product.main_image" style="height: 270px; width: 270px; object-fit: cover;" />
      </v-flex>
      <v-flex sm12 pt-4>
        <span
          class="green-security text-25-security font-weight-bold"
          v-html=" product.currency + ' ' + formatPrice(product.price)"
        ></span>
      </v-flex>
      <v-flex sm12 pt-2>
        <span class="text-14-security">{{product.name.toUpperCase()}}</span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations("products", ["setProduct"]),
    goToShowProduct(id) {
      this.$router.push({
        name: "product-show",
        params: { id: id }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

